
import { supabase } from '@/integrations/supabase/client';
import { StorageSettings } from './types';

export class SettingsService {
  /**
   * Get storage settings from the database
   */
  static async getStorageSettings(): Promise<StorageSettings> {
    try {
      const { data, error } = await supabase
        .from('admin_settings')
        .select('*')
        .in('setting_name', ['storage.provider', 'storage.base_url']);
      
      if (error) throw error;
      
      const providerSetting = data.find(item => item.setting_name === 'storage.provider');
      const baseUrlSetting = data.find(item => item.setting_name === 'storage.base_url');
      
      return {
        provider: (providerSetting?.setting_value as 'supabase' | 'local' | 'external_url') || 'supabase',
        baseUrl: baseUrlSetting?.setting_value || ''
      };
    } catch (error) {
      console.error('Error fetching storage settings:', error);
      // Return default settings if there's an error
      return {
        provider: 'supabase',
        baseUrl: ''
      };
    }
  }
}
